import saveAs from "file-saver";
import { useCallback } from "react";

export const useSaveDownloaded = (
  name: string,
  type: string,
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const save = useCallback(
    (res: any) => {
      setIsLoading && setIsLoading(false);

      const blob = new Blob([res], { type });

      saveAs(blob, name);
    },
    [name, setIsLoading, type]
  );

  return { save };
};
